import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import Gallery from "./Gallery";
import GalleryPreview from "./GalleryPreview";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import ReviewCard from './ReviewCard';
import Highlights from "./Highlights";

export default function Home() {

  const [packages, setPackages] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);
  // const [error, setError] = useState(null);

  // Fetch services dynamically
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/primedale_services")
      .then((res) => res.json())
      .then((data) => {
        const normalized = data.map((service) => ({
          ...service,
          features: typeof service.features === "string"
            ? JSON.parse(service.features)
            : service.features
        }));
        setServices(normalized);
        setLoadingServices(false);
      })
      .catch((err) => {
        console.error("Failed to load services", err);
        setLoadingServices(false);
      });
  }, []);

  // Fetch packages - FIXED to handle pagination
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/packages");
        const data = await response.json();

        // Handle both paginated and non-paginated responses
        if (data && data.data && Array.isArray(data.data)) {
          // Paginated response format: { data: [...], pagination: {...} }
          setLoading(false);
          setPackages(data.data.slice(0, 5));
        } else if (Array.isArray(data)) {
          // Direct array response format
          setPackages(data.slice(0, 5));
        } else {
          console.error("Unexpected packages response format:", data);
          setPackages([]);
        }
      } catch (err) {
        console.error("Error fetching packages:", err);
        setPackages([]);
      }
    };

    fetchPackages();
  }, []);

  const PLACE_ID = 'ChIJA-iTaAARLxgRR507s3yalPU';
  // const API_KEY = 'AIzaSyDIh3r57d3pSPwJcWBVjwsvPtTWMPz8wJM';
  useEffect(() => {
    //const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${PLACE_ID}&fields=name,rating,reviews&key=${API_KEY}`;

    const fetchData = async () => {
      await fetch(`${process.env.REACT_APP_API_URL}/reviews`)
        .then(res => res.json())
        .then(data => {
          console.log(data.result);

          setReviews(data.result || []);
        })
        .catch(err => console.log("Error:", err));
    };

    fetchData();
  }, []);
  return (
    <>
      <Helmet>
        <title>
          Primedale Tours & Travel | Corporate Travel, Safaris & Bespoke Journeys
        </title>
        <meta
          name="description"
          content="Primedale Tours & Travel provides precision-driven corporate travel management, executive retreats, bespoke safaris, and seamless travel solutions across Kenya and beyond."
        />
        <meta
          name="keywords"
          content="corporate travel Kenya, business travel management, executive retreats, safari travel Kenya, bespoke tours, Primedale Tours"
        />
        <link rel="canonical" href="https://primedaletours.com/" />
        <meta
          property="og:title"
          content="Primedale Tours & Travel | Precision in Every Journey"
        />
        <meta
          property="og:description"
          content="Expert corporate travel management, executive retreats, and bespoke safari experiences across Kenya and Africa."
        />
        <meta property="og:url" content="https://primedaletours.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Primedale Tours & Travel" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Primedale Tours & Travel | Precision in Every Journey"
        />
        <meta
          name="twitter:description"
          content="Seamless corporate travel, executive retreats, and bespoke safaris planned with precision by Primedale Tours & Travel."
        />
      </Helmet>

      <style>{`
        .service-card {
          border-radius: 18px;
          background: #ffffff;
          transition: all 0.4s ease;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .service-card:hover {
          transform: translateY(-12px) scale(1.03);
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
        }

        .service-card .icon {
          width: 85px;
          height: 85px;
          margin: 0 auto;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .service-card:hover .icon {
          transform: scale(1.15) rotate(5deg);
        }

        .service-card::before {
          content: "";
          position: absolute;
          width: 150%;
          height: 150%;
          top: -120%;
          left: -120%;
          background: linear-gradient(
            120deg,
            transparent,
            rgba(0, 123, 255, 0.15),
            transparent
          );
          transition: all 0.6s ease;
        }

        .service-card:hover::before {
          top: 100%;
          left: 100%;
        }

        .service-card:hover h5 {
          color: #0d6efd;
        }

        @media (max-width: 768px) {
          .service-card:hover {
            transform: scale(1.02);
          }
        }
        
        .package-card {
          border-radius: 18px;
          overflow: hidden;
          background: #fff;
          transition: all 0.4s ease;
          cursor: pointer;
        }

        .package-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
        }

        .package-card img {
          transition: transform 0.4s ease;
          width: 100%;
          height: 250px;
          object-fit: cover;
        }

        .package-card:hover img {
          transform: scale(1.1);
        }

        .swiper-button-next,
        .swiper-button-prev {
          color: #003366 !important;
        }

        .swiper-pagination-bullet-active {
          background: #ff831d !important;
        }
        
        .google-reviews-wrapper {
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
          transition: 0.3s;
        }

        .google-reviews-wrapper:hover {
          transform: translateY(-5px);
        }

        .google-reviews-wrapper iframe {
          width: 100%;
          border: none;
          border-radius: 20px;
        }
      `}</style>

      <div>
        {/* Hero Section */}
        <div className="container-fluid bg-dark py-5 mb-5 hero-header">
          <div className="container py-5">
            <div className="row justify-content-center py-5">
              <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                <h1 className="display-3 text-white mb-3 animated slideInDown">
                  Precision in Every Journey
                </h1>
                <p className="fs-4 text-white mb-4 animated slideInDown">
                  Explore Kenya & The World with Primedale Tours and Travel.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* About Section */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s" style={{ minHeight: 400 }}>
                <div className="position-relative h-100">
                  <img
                    className="img-fluid position-absolute w-100 h-100"
                    src="assets/img/giraffe.jpg"
                    alt="About Us"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                <h6 className="section-title bg-white text-start pe-3">
                  Introduction
                </h6>
                <h1 className="h4">
                  Welcome to <span className="">Primedale</span>
                </h1>
                <p className="mb-4">
                  Primedale Tours & Travel is a trusted <b>Kenya tours and travel company specializing in safaris, international holidays, corporate travel management, MICE services</b> and team building.
                </p>
                <p className="mb-4">
                  We curate unforgettable travel experiences across <b>Kenya, Africa, and global destinations such as Dubai, Zanzibar, Cape Town, Bali, Singapore</b> and more.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <div className="container-xxl wow fadeInUp py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h6 className="section-title bg-white text-center px-3">Our Services</h6>
              <h1>What We Offer</h1>
            </div>

            <div className="row g-4">
              {loadingServices && <p className="text-center">Loading services...</p>}

              {!loadingServices && services.length === 0 && (
                <p className="text-center">No services available at the moment.</p>
              )}

              {!loadingServices && services.map((service, index) => (
                <div className="col-lg-4 col-md-6" key={service.id}>
                  <div className="service-card text-center p-4 h-100">
                    <div className="icon mb-3 bg-primary-subtle">
                      <i className={`fa ${service.icon} fs-1 icon-color`}></i>
                    </div>
                    <h5>{service.title}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Featured Packages Section */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h6 className="section-title bg-white text-center px-3">
                Featured Packages
              </h6>
              <h1 className="mb-4">Explore Our Top Packages</h1>
            </div>

            {packages.length === 0 && !loading && (
              <p className="text-center">No packages available at the moment.</p>
            )}

            {packages.length > 0 && (
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={3}
                navigation
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000 }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
              >
                {packages.map((pkg) => (
                  <SwiperSlide key={pkg.id}>
                    <div className="package-card h-100">
                      <div className="overflow-hidden">
                        <img
                          className="img-fluid"
                          src={pkg.image}
                          alt={pkg.title}
                          style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                        />
                      </div>

                      <div className="d-flex border-bottom">
                        <small className="flex-fill text-center py-2">
                          <i className="icon-color fa fa-map-marker-alt me-2" />
                          {pkg.destination}
                        </small>
                        <small className="flex-fill text-center py-2">
                          <i className="icon-color fa fa-calendar-alt me-2" />
                          {pkg.duration}
                        </small>
                      </div>

                      <div className="text-center p-4">
                        <h5 style={{ color: "#ff831d" }}>{pkg.title}</h5>

                        <div className="d-flex justify-content-center mt-3">
                          <Link
                            to={`/package-details/${pkg.slug}`}
                            className="btn btn-sm navyblue-bg px-3"
                            style={{ borderRadius: "30px" }}
                          >
                            View Details
                          </Link>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
        {/* <Highlights /> */}
        <GalleryPreview />
        {/* Google Reviews Section */}
        {/* Google Reviews Section */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h6 className="section-title bg-white text-center px-3">
                Google Reviews
              </h6>
              <h1 className="mb-4">What Clients Say About Us</h1>
              <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
                <i className="fab fa-google fa-2x text-danger"></i>
                <span className="fs-4 fw-bold" style={{ color: "#003366" }}>{reviews?.rating || 0}</span>
                <div className="text-warning">
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star-half-alt"></i>
                </div>
                <span className="text-muted">{reviews.reviews?.length || 0} reviews</span>
              </div>
            </div>
          </div>

        </div>


        <div className="container-xxl py-5">
          <div className="">
            {

              reviews.reviews?.length > 0 ? (
                <Swiper
                  className="views"
                  modules={[Autoplay]} // Remove Navigation and Pagination
                  spaceBetween={30}
                  slidesPerView={3}
                  autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                    stopOnLastSlide: false,
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}
                  speed={5000} // Slower smooth scroll
                  loop={true}
                  allowTouchMove={false} // Optional: disable touch for pure auto-scroll
                >
                  {[...reviews.reviews, ...reviews.reviews, ...reviews.reviews].map((rev, index) => (
                    <SwiperSlide key={index}>
                      <ReviewCard review={rev} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <p></p>
              )}
          </div>
        </div>

        <style>{`
            .swiper-slide {
              height: clamp(350px, 70vh, 500px);
              display: flex;
              // align-items: stretch;
            }
              @media (max-width: 576px) {
              .views {
              height: clamp(350px, 50vh, 650px);
              display: flex;
              // align-items: stretch;
            }
            .swiper-slide .review-card {
              min-height: 20vh !important;
              height: 100% !important;
            }
            
            
            
            .swiper-slide {
              transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1) !important;
            }
            
            .swiper-slide {
              // opacity: 0.7;
              transition: opacity 0.5s ease-in-out;
            }
            
            .swiper-slide-active {
              opacity: 1;
            }
              
          `}</style>
        {/* View All Reviews Button */}
        <div className="text-center mt-5">
          <a
            href="https://maps.app.goo.gl/3gDfcWkT3tWC5GMk9"
            target="_blank"
            rel="noopener noreferrer"
            className="btn px-4 py-2"
            style={{
              backgroundColor: "#003366",
              color: "white",
              borderRadius: "30px",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#ff831d";
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#003366";
              e.target.style.transform = "scale(1)";
            }}
          >
            <i className="fab fa-google me-2"></i>
            View All Reviews on Google
          </a>
        </div>

      </div>
    </>
  );
}